//MobileHomesIBM.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as EditValuesIBM from "./EditValuesIBM";
import * as Settings from "../Settings";
import * as SignIn_Auth0 from "../Util/SignIn_Auth0";
import * as SnackBar from "../Util/SnackBar";
import * as Spinner from "../Util/Spinner";
import * as TextField_IBM from "./TextField_IBM";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as Widgets from "../Widgets/Widgets";

import { Button, Icon, IconButton, Paper, Tooltip, Typography } from "@mui/material";

import { deepOrange, lightBlue } from '@mui/material/colors';

import Axios, { AxiosResponse } from "axios";

import React from "react";

const toolName: string = "Mobile Homes";
let saveDisabled: boolean;
let uniqueID: string;
let curDatas: EditValuesIBM.iCurrentValuesIBM[] = [];
let startingUp: boolean;

//String version of data.
interface iStringData {
   mobileHomeAny?: string;
   mobileHome6Any?: string;
}
let sds: iStringData[]; //String data's.

//Get string value.
function getStringValue(inValue: any): string {
   let outValue: string = Util.formatTextValue(inValue, "Comma");
   if (outValue === "0") {
      outValue = "";
   }
   return outValue;
}

//Round to nearest 100.
function nearest100(inValue: number): number {
   return Util.parseInteger(((inValue + 50) / 100).toString()) * 100;
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of Edit Render");

   if (DrawerMenu.curToolName === "") {
      return (<div />);
   }

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Wire up component for each time render is called, but not on refresh.
   const [initComponent, setState] = React.useState(() => {

      //Clear previous.
      startingUp = true;
      saveDisabled = true;
      uniqueID = Util.uid();
      curDatas = [];

      //Get current values from IBM server.
      const ajaxData: Default.iAjaxData = { action: "getMobileHomesIBM", pinList: [EditValuesIBM.activePIN] };

      const webAPI_path = Util_App.getWebAPI_path();

      Axios.post(webAPI_path, ajaxData)
         .then(function (response) {
            if (!response) {
               Util.errMsg("ajax results from server are null");
               return;
            }
            curDatas = response.data;

            const errMsg: string = curDatas[curDatas.length - 1].errMsg;
            if (errMsg !== "") {
               SnackBar.show(errMsg);
               return;
            }

            //Set string version of market values.
            sds = [];
            for (const curData of curDatas) {
               const sdRec: iStringData = { mobileHomeAny: getStringValue(curData.mobileHome), mobileHome6Any: getStringValue(curData.mobileHome6) };
               sds.Add(sdRec);
            }

            startingUp = false;
            refresh();
         })
         .catch(function (error) {
            Spinner.hide();
            Util.errMsg("ajax error setting IBM values.", error);
         });
   });

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Component did update.
   React.useEffect(() => {
      Widgets.setPosition();
   });

   //Close this tool.
   function close() {
      DrawerMenu.closeTool();
   }

   //Market or pickup value changed.
   function valueChanged(fieldCode: string, value: number, ii: number) {
      //Util.logMsg("valueChanged fieldCode, inValue: " + fieldCode + " " + value);
      const curData: EditValuesIBM.iCurrentValuesIBM = curDatas[ii];

      //Improvements.
      if (fieldCode === "Mobile Home") {
         curData.mobileHome = value;

      } else if (fieldCode === "Mobile Home 6%") {
         curData.mobileHome6 = value;
      }

      calcTotalValues(curData);
      curData.hasEdits = true;

      if (saveDisabled) {
         saveDisabled = false;
         refresh();
      }
   }

   //Recalculate totals.
   function calcTotalValues(curData: EditValuesIBM.iCurrentValuesIBM) {

      //Market value totals computation.
      curData.marketLand = curData.residenceLand + curData.otherLand + curData.agricultureLand;
      curData.marketImp = curData.residence + curData.other + curData.agriculture + curData.agUse + curData.mobileHome + curData.mobileHome6;
      curData.marketTotal = curData.marketLand + curData.marketImp;

      curData.marketLand = nearest100(curData.marketLand);
      curData.marketImp = nearest100(curData.marketImp);
      curData.marketTotal = nearest100(curData.marketTotal);

      //Cap value totals computation.
      curData.capLand = curData.taxLand_reMast * 1.15;
      curData.capImp = curData.taxImp_reMast * 1.15;
      curData.capTotal = curData.taxTotal_reMast * 1.15;
      const capTotal: number = curData.capTotal;

      curData.capLand = nearest100(curData.capLand);
      curData.capImp = nearest100(curData.capImp);
      curData.capTotal = nearest100(curData.capTotal);

      //Reduce cap if greater than unrounded value.
      if (curData.capTotal > capTotal) {
         curData.capTotal -= 100;

         if ((curData.capLand + curData.capImp) > curData.capTotal) {
            if (curData.capImp >= curData.capLand) {
               curData.capImp = curData.capTotal - curData.capLand;
            } else {
               curData.capLand = curData.capTotal - curData.capImp;
            }
         }
      }

      //Taxable value totals computation.
      curData.taxLand = curData.marketLand;
      curData.taxImp = curData.marketImp;
      curData.taxTotal = curData.marketTotal;

      if (curData.marketTotal > curData.capTotal) {
         curData.taxLand = curData.capLand;
         curData.taxImp = curData.capImp;
         curData.taxTotal = curData.capTotal;
      }
   }

   //Save values.
   function saveValues(event, inCurData?: EditValuesIBM.iCurrentValuesIBM) {
      if (Spinner.busy) {
         return; //Quit if busy.
      }
      Spinner.show();

      //Send market values to server.
      const reAssData: EditValuesIBM.iCurrentValuesIBM[] = [];

      let dataToProcess: EditValuesIBM.iCurrentValuesIBM[] = curDatas;
      if (inCurData) {
         dataToProcess = [inCurData]; //Process 1 record from "Done" button click.
      }

      for (const curData of dataToProcess) {
         if (curData.hasEdits) {
            reAssData.Add(curData);
            curData.hasEdits = false;
            curData.doneFlag = true;
            curData.initials = EditValuesIBM.getUserInitials(SignIn_Auth0.userName);
            curData.dateChanged = new Date().ToShortDate();
         }
      }

      const ajaxData: Default.iAjaxData = { action: "saveAppraisedValuesMobileHomeIBM", userName: SignIn_Auth0.userName, reAssData: reAssData };

      const webAPI_path = Util_App.getWebAPI_path();

      Axios.post(webAPI_path, ajaxData)
         .then(function (response) {
            setTimeout(function () { Spinner.hide(); }, 500); //Wait to avoid fumble finger multiple clicks.

            if (!response) {
               Util.errMsg("ajax results from server are null");
               return;
            }
            if (response.data.errMsg !== "") {
               SnackBar.show(response.data.errMsg);
               return;
            }
            SnackBar.show("Successfully changed mobile home values", 2);

            //Enable or disable save all button.
            saveDisabled = true;
            for (const curData of curDatas) {
               if (curData.hasEdits) {
                  saveDisabled = false;
               }
            }

            refresh();
         })
         .catch(function (error) {
            Spinner.hide();
            Util.errMsg("ajax error setting IBM values.", error);
         });
   }

   //Set the reassessment done flag and save edits for this record only.
   function setDone(ii: number) {
      const curData: EditValuesIBM.iCurrentValuesIBM = curDatas[ii];
      curData.hasEdits = true;
      saveValues(null, curData);
   }

   //Photo click event.
   function photoClick(ii: number) {
      const url: string = curDatas[ii].mhPicture;
      window.open(url, "MHPic");
   }

   //Build a mobile home row.
   function buildRow(curData: EditValuesIBM.iCurrentValuesIBM, ii: number): any[] {
      const jsx: any[] = [];
      const sd: iStringData = sds[ii];

      //Square footage.
      const sqFt: string = Util.formatTextValue(curData.sqFt, "Comma");

      //Done or not done.
      let doneDisabled: boolean = false;
      let doneText: string = "Not done";
      let initialsText: string = "";
      let dateChangedText: string = "";
      let byText: string = "";
      let onText: string = "";

      if (curData.doneFlag) {
         doneDisabled = true;
         doneText = "Done";
         initialsText = curData.initials;
         dateChangedText = curData.dateChanged;
         byText = "By: ";
         onText = "On: ";
      }

      //Set 6% visible.
      let sixPerVisible: boolean = false;
      if (curData.mobileHome6Orig) {
         sixPerVisible = true;
      }

      //IDs.
      const mobileHomeId: string = "MobileHome-id" + ii;
      const mobileHome6Id: string = "MobileHome6-id" + ii;

      //Styles.
      const styles: any = {
         paper: { backgroundColor: Settings.paperColor, marginTop: 12, padding: 4, paddingTop: 0 },

         table: { width: '100%', fontWeight: 500, overflowX: 'auto', border: '1px solid silver', borderCollapse: 'collapse', marginTop: 5, marginBottom: 5, fontFamily: 'Roboto, Helvetica, Arial, Verdana' },
         body: { cursor: 'default' },
         miscStyle: { color: deepOrange[900], fontWeight: 500, fontSize: Settings.detailsFontSize },

         headingTitleCell: { color: lightBlue.A700, backgroundColor: Settings.headingColor, fontWeight: 500, textAlign: 'center', padding: 3, fontSize: Settings.detailsFontSize },
         headingCell: { backgroundColor: Settings.headingColor, fontWeight: 500, textAlign: 'center', padding: 3, fontSize: Settings.detailsFontSize },

         bodyCellCenter: { backgroundColor: Settings.leftPanelLabelColor, textAlign: 'center', padding: 3, fontSize: Settings.detailsFontSize, borderTop: '1px solid silver' },
         bodyCellDescr: { width: 220, backgroundColor: Settings.leftPanelLabelColor, textAlign: 'center', padding: 3, fontSize: Settings.detailsFontSize, borderTop: '1px solid silver' },
      };

      jsx.push(
         <Paper key={curData.mobileHomeNo} style={styles.paper}>

            <div className="app-flex-row-start" style={{ padding: 0 }}>
               <div className="app-flex-column-around">
                  <div>
                     <Tooltip enterDelay={300} leaveDelay={200} placement="right-start"
                        title={
                           <React.Fragment>
                              <img src={curData.mhPicture} width="480px" />
                           </React.Fragment>
                        }
                     >
                        <img src={curData.mhPicture} height="100px" onClick={photoClick.bind(null, ii)} style={{ cursor: "pointer" }} />
                     </Tooltip>
                  </div>

                  <Button disabled={doneDisabled} variant="contained" size="medium" color="primary" onClick={setDone.bind(null, ii)} title="Set reassessment done and save edits for this mobile home">
                     Done
                  </Button>
               </div>

               <div className="app-flex-column-start" style={{ padding: 5, paddingBottom: 0 }}>
                  <Typography variant="body1">
                     Mobile Home: <span style={styles.miscStyle}>{doneText}</span>
                     &nbsp;&nbsp;&nbsp;&nbsp;{byText}<span style={styles.miscStyle}>{initialsText}</span>
                     &nbsp;&nbsp;&nbsp;&nbsp;{onText}<span style={styles.miscStyle}>{dateChangedText}</span>
                  </Typography>

                  <table style={styles.table}>
                     <thead>
                        <tr tabIndex={-1}>
                           <th style={styles.headingCell}>MH#</th>
                           <th style={styles.headingCell}>Lot</th>
                           <th style={styles.headingCell}>SqFt</th>
                           <th style={styles.headingCell}>Description</th>
                        </tr>
                     </thead>

                     <tbody style={styles.body}>
                        <tr tabIndex={-1}>
                           <td style={styles.bodyCellCenter}>{curData.mobileHomeNo}</td>
                           <td style={styles.bodyCellCenter}>{curData.lotNum}</td>
                           <td style={styles.bodyCellCenter}>{sqFt}</td>
                           <td style={styles.bodyCellDescr}>{curData.mhDescription}</td>
                        </tr>

                     </tbody>
                  </table>

                  <table style={styles.table}>
                     <thead>
                        <tr tabIndex={-1}>
                           <th style={styles.headingTitleCell}>Improvements</th>
                           <th style={styles.headingCell}>Last</th>
                           <th style={styles.headingCell}>Market</th>
                           <th style={styles.headingCell}>Change</th>
                        </tr>
                     </thead>

                     <tbody style={styles.body}>
                        {!sixPerVisible && <TextField_IBM.Render
                           id={mobileHomeId}
                           uid={uniqueID}
                           ii={ii}
                           fieldCode="Mobile Home"
                           orig={curData.mobileHomeOrig}
                           value={curData.mobileHome}
                           valueAny={sd.mobileHomeAny}
                           onChange={valueChanged}
                        />
                        }
                        {sixPerVisible && <TextField_IBM.Render
                           id={mobileHome6Id}
                           uid={uniqueID}
                           ii={ii}
                           fieldCode="Mobile Home 6%"
                           orig={curData.mobileHome6Orig}
                           value={curData.mobileHome6}
                           valueAny={sd.mobileHome6Any}
                           onChange={valueChanged}
                        />
                        }
                     </tbody>
                  </table>

               </div>  {/* End col1 container. */}
            </div>  {/* End row1 container. */}

         </Paper>,
      ); //end jsx.push.
      return jsx;
   }

   //Quit if starting up.
   if (startingUp) {
      return (<div />);
   }

   //Done or not done.
   let numRemaining: number = 0;
   for (const rec of curDatas) {
      if (!rec.doneFlag) {
         numRemaining++;
      }
   }

   let remainingText: string = "All Done";
   if (numRemaining > 0) {
      remainingText = numRemaining + " Remaining";
   }

   const scrollDivID: string = toolName.replace(" ", "_") + "_Scroll";

   //Styles.
   const styles2: any = {
      miscStyle: { color: deepOrange[900], fontWeight: 500, fontSize: Settings.detailsFontSize },
   };

   return (
      <Paper>
         <div style={Default.styles.appToolHeading}>
            <Typography variant="body1" style={{ marginLeft: 12 }}>
               Edit mobile home values: <span style={styles2.miscStyle}>{remainingText}</span>
            </Typography>

            <Button disabled={saveDisabled} variant="contained" size="medium" color="primary" onClick={saveValues} title="Save all values">
               Save All
            </Button>

            <IconButton color="primary" onClick={close} title="Close" aria-label="Close" >
               <Icon>close</Icon>
            </IconButton>
         </div>

         <div id={scrollDivID} style={{ overflow: "auto" }}>
            {curDatas.map(function (curData: EditValuesIBM.iCurrentValuesIBM, i: number) {
               return (buildRow(curData, i));
            })}
         </div>
      </Paper>
   ); //end return.

} //end function.
